import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { FeedbackProvider, ThemeProvider } from '@app/ui'
import { AuthProvider } from '@/auth/AuthContext'
import { EmailPreviewProvider } from '@/email/EmailPreviewProvider'
import { PdfPreviewProvider } from '@/pdf/PdfPreviewProvider'
import { installZodMessages } from '@lib/validators/zod-messages'
import { router } from '@/router'
import '@/index.css'

// Plain-English validation messages for every schema, form and wire alike.
installZodMessages()

/**
 * A single QueryClient for the app. `retry: 1` keeps failed reads from hammering
 * the API, and a short `staleTime` is set per-query in the hooks.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root was not found in index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <FeedbackProvider>
          <PdfPreviewProvider>
            <EmailPreviewProvider>
              <AuthProvider>
                <RouterProvider router={router} />
              </AuthProvider>
            </EmailPreviewProvider>
          </PdfPreviewProvider>
        </FeedbackProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
